const Menu =  [
  { header: 'Apps' },
  {
    title: 'menu.dashboard',
    group: 'apps',
    icon: 'dashboard',
    name: 'dashboard',
   // href : "dashboard"
  },
  {
    title: 'menu.init_doc',
    group: 'apps',
    icon: 'featured_play_list',
    name: 'InitialDoc',
   // href : "dashboard"
  },
  {
    title: 'menu.shipment_check',
    icon: 'find_in_page',
    group: 'apps',
    name: 'shipmentpacktrack', 
    component: 'shipmentpacktrack'    
  },
  {
    title: 'menu.ship_parcel',
    icon: 'how_to_vote',
    group: 'apps',
    name: 'shipparcel', 
    component: 'shipparcel'    
  },
  {
    title: 'menu.move_parcel',
    icon: 'local_shipping',
    group: 'apps',
    name: 'moveparcel', 
    component: 'moveparcel' 
    
  },
  {
    title: 'menu.drop_parcel',
    icon: 'rate_review',
    group: 'apps',
    name: 'dropparcel', 
    component: 'dropparcel'     
  },
  {
    title: 'menu.drop_image_confirm',
    icon: 'verified_user',
    group: 'apps',
    name: 'dropimageconfirm',
    component: 'dropimageconfirm' 
  }
];

  // reorder menu
  // Menu.forEach((item) => {
  //   if (item.items) {
  //     item.items.sort((x, y) => {
  //       let textA = x.title.toUpperCase();
  //       let textB = y.title.toUpperCase();
  //       return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
  //     });
  //   }
  // });
  
  export default Menu;
  